import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '../../store';
import Parse from 'parse';
import { OwnerId, } from '../models/models';
import * as Env from "../../environments";





export interface TrackId {
    title: string;
    createdAt: Date;
    updatedAt: Date;
    sessionToken: string;
    objectId: string;
    __type: string;
    className: string;
}

export interface PoiId {
    title: string;
    createdAt: Date;
    updatedAt: Date;
    sessionToken: string;
    objectId: string;
    __type: string;
    className: string;
}

export interface UserId {
    username: string;
    createdAt: Date;
    updatedAt: Date;
    sessionToken: string;
    objectId: string;
    __type: string;
    className: string;
}

export interface VideoData {
    id: string;
    mp4: string;
}


export interface Video {


    status: string;
    owner_id: OwnerId;
    owner_type: string;
    user_id: UserId;
    poi_id: PoiId;
    track_id: TrackId;
    title: string;
    description: string;
    data: VideoData;

    createdAt: Date;
    updatedAt: Date;
    objectId: string;

}

export interface ResponseObject {
    results: Video[];
    count: number;
}

export interface ParseResponseObject {
    results: Parse.Object[];
    count: number;
}


export interface VideoState {
    isLoading: boolean;
    uploading: boolean;
    video?: ResponseObject;
    pagination: {
        size: number,
        page: number,
        searchText: string,
        status: string[],
        userTypes: string[],
        ascending: boolean,
        sortColumn: string
    }

}


const initialState: VideoState = {
    isLoading: false,
    uploading: false,
    video: {
        count: 0,
        results: []
    },
    pagination: {
        size: 10,
        page: 0,
        searchText: "",
        status: ["published"],
        ascending: false,
        sortColumn: 'updatedAt',
        userTypes: ['parco', 'abituale', 'residente', 'turista']


    }

};



const getPaginatedVideo = createAsyncThunk(
    'getPaginatedVideo',
    // async ({ size, page, searchText, status, sortColumn = 'updatedAt', ascending = false }: { size: number, page: number, searchText?: string, status?: string[], sortColumn?: string, ascending?: boolean }) => {
    async (_, { getState }) => {
        const { size, page, searchText, status, userTypes, ascending, sortColumn } = (getState() as AppState).video.pagination;

        const query = new Parse.Query('Video');
        query.withCount();
        query.include('owner_id');
        query.include('poi_id')
        query.include('track_id')


        if (searchText) {
            query.fullText('title', searchText);
        }

        if (status) {

            query.containedIn('status', status);
        }

        if (userTypes) {
            query.containedIn('owner_type', userTypes)
        }

        if (sortColumn !== 'poi_id') {
            if (ascending) {
                query.ascending(sortColumn)
            }
            else {
                query.descending(sortColumn)
            }
        }


        query.skip(page * size);
        query.limit(size)
        // query.notEqualTo('status', 'deleted')
        // query.ascending('title');
        const response = (await query.find()) as unknown as ParseResponseObject;
        const count = response.count;
        const results = response.results.map((p) => p.toJSON());

        let res: ResponseObject = { count: count, results: results } as unknown as ResponseObject;
        if (sortColumn === 'poi_id') {
            res.results.sort((a, b) => {
                const titleA = a.poi_id ? a.poi_id.title : a.track_id.title;
                const titleB = b.poi_id ? b.poi_id.title : b.track_id.title;

                return titleA > titleB ? 1 : (titleA < titleB ? -1 : 0)
            })

            if (ascending) {
                res.results.reverse()
            }

        }
        // res.results.sort((a, b) => {
        //     const titleA = a.poi_id ? a.poi_id.title : a.track_id.title;
        //     const titleB = b.poi_id ? b.poi_id.title : b.track_id.title;

        //     return titleA > titleB ? 1 : (titleA < titleB ? -1 : 0)
        // })





        return res;

    }
)



const getVideo = createAsyncThunk(
    'getVideo',
    async () => {

        const query = new Parse.Query('Video');
        query.withCount();
        const response = (await query.find()) as unknown as ParseResponseObject;
        const count = response.count;
        const results = response.results.map((p) => p.toJSON());





        return { count: count, results: results } as unknown as ResponseObject;

    }
)

const getVideoOfObject = createAsyncThunk(
    'getVideoOfObject',
    async ({ objectId, type }: { objectId: string, type: 'Poi' | 'Track' }) => {



        const query = new Parse.Query('Video');
        const Classe = Parse.Object.extend(type);
        const obj = Classe.createWithoutData(objectId);

        query.equalTo(type === 'Poi' ? 'poi_id' : 'track_id', obj);
        query.equalTo('status', 'published');
        query.limit(10000)
        query.descending('updatedAt')


        query.withCount();
        const response = (await query.find()) as unknown as ParseResponseObject;
        const count = response.count;
        const results = response.results.map((p) => p.toJSON());





        return { count: count, results: results } as unknown as ResponseObject;

    }
);

const removeVideo = createAsyncThunk(
    'removeVideo',
    async ({ id, objectId, type, view }: { id: string, objectId: string, type: "Poi" | "Track", view: 'list' | 'detail' }, { dispatch, getState }) => {

        const query = new Parse.Query('Video');
        const v = await query.get(id);
        v.set('status', 'deleted')
        await v.save();

        // const queryVideo = new Parse.Query('Video');
        // const Classe = Parse.Object.extend(type);
        // const obj = Classe.createWithoutData(objectId);

        // queryVideo.equalTo(type === 'Poi' ? 'poi_id' : 'track_id', obj);
        // queryVideo.equalTo('status', 'published');
        // const res = await queryVideo.find();
        // const results = res.map((p) => p.toJSON());


        if (view === 'list') {
            const { pagination, images } = (getState() as AppState).image;
            // dispatch(getImagesOfObject({ objectId, type }))
            if (images && pagination) dispatch(getPaginatedVideo())

        }
        else {

            dispatch(getVideoOfObject({ objectId, type }))


        }
        // const { pagination, video } = (getState() as AppState).video;
        // if (video) if (pagination) dispatch(getPaginatedVideo())


        // return { count: res.length, results: results } as unknown as ResponseObject;


    }
)

const definitelyRemoveVideo = createAsyncThunk(
    'definitelyRemoveVideo',
    async ({ id, objectId, type, view }: { id: string, objectId: string, type: "Poi" | "Track", view: 'list' | 'detail' }, { dispatch, getState }) => {

        const query = new Parse.Query('Video');
        const v = await query.get(id);
        v.set('status', 'defdeleted')
        await v.save();

        // const queryVideo = new Parse.Query('Video');
        // const Classe = Parse.Object.extend(type);
        // const obj = Classe.createWithoutData(objectId);

        // queryVideo.equalTo(type === 'Poi' ? 'poi_id' : 'track_id', obj);
        // queryVideo.equalTo('status', 'published');
        // const res = await queryVideo.find();
        // const results = res.map((p) => p.toJSON());

        // dispatch(getVideoOfObject({ objectId, type }))
        if (view === 'list') {
            const { pagination, images } = (getState() as AppState).image;
            // dispatch(getImagesOfObject({ objectId, type }))
            if (images && pagination) dispatch(getPaginatedVideo())

        }
        else {

            dispatch(getVideoOfObject({ objectId, type }))


        }
        // const { pagination, video } = (getState() as AppState).video;
        // if (video) if (pagination) dispatch(getPaginatedVideo())


        // return { count: res.length, results: results } as unknown as ResponseObject;


    }
)


const deleteVideo = createAsyncThunk(
    'deleteVideo',
    async ({ id, objectId, type, view }: { id: string, objectId: string, type: "Poi" | "Track", view: 'list' | 'detail' }, { dispatch, getState }) => {

        const query = new Parse.Query('Video');
        const v = await query.get(id);
        v.set('status', 'deleted')
        await v.save();




        if (view === 'list') {
            const { pagination, images } = (getState() as AppState).image;
            // dispatch(getImagesOfObject({ objectId, type }))
            if (images && pagination) dispatch(getPaginatedVideo())

        }
        else {

            dispatch(getVideoOfObject({ objectId, type }))


        }




    }
)

const definitelyDeleteVideo = createAsyncThunk(
    'definitelyDeleteVideo',
    async ({ id, objectId, type, view }: { id: string, objectId: string, type: "Poi" | "Track", view: 'list' | 'detail' }, { dispatch, getState }) => {

        const query = new Parse.Query('Video');
        const v = await query.get(id);
        v.set('status', 'defdeleted')
        await v.save();



        if (view === 'list') {
            const { pagination, images } = (getState() as AppState).image;
            // dispatch(getImagesOfObject({ objectId, type }))
            if (images && pagination) dispatch(getPaginatedVideo())

        }
        else {

            dispatch(getVideoOfObject({ objectId, type }))


        }

    }
)


export const uploadVideoFile = createAsyncThunk(
    'uploadVideoFile',
    async ({ file, objectId, type }: { file: File, objectId: string, type: "Poi" | "Track" }) => {
        if (file != null) {

            const session = await Parse.Session.current();

            var myHeaders = new Headers();
            // myHeaders.append("Authorization", "Bearer eyJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxLCJleHAiOjE2NjI2OTY2ODV9.6HTB8lttPyCWoETKsARHrAPTwAZg9gRx_tScY_DL13A");
            myHeaders.append('Session', await session.getSessionToken())
            var formdata = new FormData();
            formdata.append("video", file, file.name);
            formdata.append("title", "fff");

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formdata,
            };

            try {

                await fetch(`${Env.API_URL}/${type.toLowerCase()}s/${objectId}/videos`, requestOptions)

                const queryImage = new Parse.Query('Video');
                const Classe = Parse.Object.extend(type);
                const obj = Classe.createWithoutData(objectId);

                queryImage.equalTo(type === 'Poi' ? 'poi_id' : 'track_id', obj);
                queryImage.equalTo('status', 'published');
                queryImage.limit(10000)
                queryImage.descending('updatedAt')
                const res = await queryImage.find();
                const results = res.map((p) => p.toJSON());

                await new Promise((resolve) => setTimeout(resolve, 4000));

                return { count: res.length, results: results } as unknown as ResponseObject;

            } catch (error) {
                console.log(error)
                const queryImage = new Parse.Query('Video');
                const Classe = Parse.Object.extend(type);
                const obj = Classe.createWithoutData(objectId);

                queryImage.equalTo(type === 'Poi' ? 'poi_id' : 'track_id', obj);
                queryImage.equalTo('status', 'published');
                queryImage.limit(10000)
                queryImage.descending('updatedAt')
                const res = await queryImage.find();
                const results = res.map((p) => p.toJSON());

                await new Promise((resolve) => setTimeout(resolve, 4000));

                return { count: res.length, results: results } as unknown as ResponseObject;

            }
        }
    }
);


interface PaginationParams {
    page?: number,
    size?: number,
    searchText?: string,
    status?: string[],
    userTypes?: string[],
    ascending?: boolean,
    sortColumn?: string,
}

export const videoSlice = createSlice({
    name: 'video',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setPaginationParams: (state: VideoState, action: PayloadAction<PaginationParams>) => {
            const { page, size, searchText, sortColumn, ascending, userTypes, status } = action.payload

            if (page !== undefined) state.pagination.page = page
            if (size) state.pagination.size = size
            if (searchText) state.pagination.searchText = searchText
            if (sortColumn) state.pagination.sortColumn = sortColumn
            if (ascending !== undefined) state.pagination.ascending = ascending
            if (userTypes) state.pagination.userTypes = userTypes
            if (status) state.pagination.status = status

            return state
        }

    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {
        builder
            .addCase(getPaginatedVideo.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPaginatedVideo.rejected, (state, action) => {
                state.isLoading = false;

            })
            .addCase(getPaginatedVideo.fulfilled, (state, action) => {
                state.isLoading = false;
                state.video = action.payload;
            })
            .addCase(getVideo.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getVideo.rejected, (state, action) => {
                state.isLoading = false;

            })
            .addCase(getVideo.fulfilled, (state, action) => {
                state.isLoading = false;
                state.video = action.payload;
            })
            .addCase(removeVideo.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(removeVideo.rejected, (state) => {
                state.isLoading = false;

            })
            .addCase(removeVideo.fulfilled, (state, action) => {
                state.isLoading = false;
                // state.video = action.payload;

            })
            .addCase(definitelyRemoveVideo.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(definitelyRemoveVideo.rejected, (state) => {
                state.isLoading = false;

            })
            .addCase(definitelyRemoveVideo.fulfilled, (state, action) => {
                state.isLoading = false;
                // state.video = action.payload;

            })
            .addCase(deleteVideo.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(deleteVideo.rejected, (state) => {
                state.isLoading = false;

            })
            .addCase(deleteVideo.fulfilled, (state, action) => {
                state.isLoading = false;
                // state.video = action.payload;

            })
            .addCase(definitelyDeleteVideo.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(definitelyDeleteVideo.rejected, (state) => {
                state.isLoading = false;

            })
            .addCase(definitelyDeleteVideo.fulfilled, (state, action) => {
                state.isLoading = false;
                // state.video = action.payload;

            })
            .addCase(getVideoOfObject.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getVideoOfObject.rejected, (state) => {
                state.isLoading = false;

            })
            .addCase(getVideoOfObject.fulfilled, (state, action) => {
                state.isLoading = false;
                state.video = action.payload;

            })
            .addCase(uploadVideoFile.pending, (state) => {
                state.uploading = true;
            })
            .addCase(uploadVideoFile.rejected, (state) => {
                state.uploading = false;

            })
            .addCase(uploadVideoFile.fulfilled, (state, action) => {
                state.uploading = false;
                state.video = action.payload;

            });
    },
});




// export const { getPois } = poisSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: AppState) => state.counter.value)`

export const selectVideo = (state: AppState) => state.video;
export const selectPagination = (state: AppState) => state.video.pagination;

export const videoActions = { ...videoSlice.actions, getPaginatedVideo, getVideo, definitelyRemoveVideo, removeVideo, deleteVideo, definitelyDeleteVideo, getVideoOfObject, uploadVideoFile }

export default videoSlice.reducer;
